module.exports = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
};
